var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 12.3931C12.4234 12.3931 13.9827 10.8338 13.9827 8.91033C13.9827 6.98683 12.4234 5.42752 10.4999 5.42752C8.5764 5.42752 7.01709 6.98683 7.01709 8.91033C7.01709 10.8338 8.5764 12.3931 10.4999 12.3931Z",
    stroke: "#3873FF",
    strokeWidth: 1.49625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.55127 17.8263C5.17294 16.8058 6.04666 15.9625 7.08844 15.3773C8.13022 14.7921 9.30502 14.4847 10.4999 14.4847C11.6948 14.4847 12.8696 14.7921 13.9114 15.3773C14.9532 15.9625 15.8268 16.8058 16.4486 17.8263",
    stroke: "#3873FF",
    strokeWidth: 1.49625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5001 20.0553C15.5013 20.0553 19.5555 16.0012 19.5555 11C19.5555 5.99891 15.5013 1.9447 10.5001 1.9447C5.49903 1.9447 1.44482 5.99891 1.44482 11C1.44482 16.0012 5.49903 20.0553 10.5001 20.0553Z",
    stroke: "#3873FF",
    strokeWidth: 1.49625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/Account.3e746047399e54f7caf8b2eef312766a.svg";
export { ForwardRef as ReactComponent };